import { importSharedPlanOutput, importSharedPlanPath, myPlanSharePath, PLAN_SHARE_ROUTES, planShareSummary, planSharesOutput, sharedPlanOutput, sharedPlanPath, } from "@repo/contract/community";
import { z } from "zod";
import { getJson, sendJson, } from "../core/request";
import { planKeys } from "../plan/keys";
export const planShareKeys = {
    mine: () => ["community", "plan-shares"],
    shared: (shareId, locale) => ["community", "shared-plan", shareId, locale],
};
/** `GET /me/plan/shares` — the caller's live shares, newest first. */
export function fetchMyPlanShares(api, init) {
    return getJson(api, PLAN_SHARE_ROUTES.mine, planSharesOutput, init);
}
/** `GET /me/shared-plans/:shareId` — the snapshot, names in `locale`. */
export function fetchSharedPlan(api, shareId, locale, init) {
    return getJson(api, `${sharedPlanPath(shareId)}?locale=${locale}`, sharedPlanOutput, init);
}
export function myPlanSharesOptions(api) {
    return {
        queryFn: ({ signal }) => fetchMyPlanShares(api, { signal }),
        queryKey: planShareKeys.mine(),
        staleTime: 60_000,
    };
}
export function sharedPlanOptions(api, shareId, locale) {
    return {
        queryFn: ({ signal }) => fetchSharedPlan(api, shareId, locale, { signal }),
        queryKey: planShareKeys.shared(shareId, locale),
        staleTime: 5 * 60_000,
    };
}
/** `POST /me/plan/shares` — snapshot the plan in effect. */
export function createPlanShareMutation(api) {
    return {
        invalidates: [planShareKeys.mine()],
        mutationFn: () => sendJson(api, "POST", PLAN_SHARE_ROUTES.mine, undefined, planShareSummary),
        mutationKey: ["community", "plan-share", "create"],
    };
}
const revokedOutput = z.object({ revoked: z.literal(true) });
/** `DELETE /me/plan/shares/:shareId` — the link stops working. */
export function revokePlanShareMutation(api) {
    return {
        invalidates: [planShareKeys.mine()],
        mutationFn: (shareId) => sendJson(api, "DELETE", myPlanSharePath(shareId), undefined, revokedOutput),
        mutationKey: ["community", "plan-share", "revoke"],
    };
}
/** `POST /me/shared-plans/:shareId/import` — the caller's new DRAFT. */
export function importSharedPlanMutation(api) {
    return {
        invalidates: [planKeys.draftAll],
        mutationFn: (shareId) => sendJson(api, "POST", importSharedPlanPath(shareId), undefined, importSharedPlanOutput),
        mutationKey: ["community", "plan-share", "import"],
    };
}
//# sourceMappingURL=plan-share.js.map